export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install JIRA Desktop', command: 'Web-based platform - bookmark in browser' },
      { step: 'Install Confluence', command: 'Web-based platform - bookmark in browser' },
      { step: 'Install Zoom', command: 'brew install --cask zoom' },
      { step: 'Install Microsoft Office', command: 'brew install --cask microsoft-office' },
      { step: 'Install Miro', command: 'brew install --cask miro' }
    ],
    windows: [
      { step: 'Install Chrome', command: 'choco install googlechrome' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' },
      { step: 'Install Azure DevOps', command: 'Web-based platform - bookmark in browser' },
      { step: 'Install Teams', command: 'choco install microsoft-teams' },
      { step: 'Install Zoom', command: 'choco install zoom' },
      { step: 'Install Miro', command: 'choco install miro' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install LibreOffice', command: 'sudo apt install libreoffice' },
      { step: 'Install Zoom', command: 'sudo snap install zoom-client' },
      { step: 'Install Git', command: 'sudo apt install git' },
      { step: 'Install VS Code', command: 'sudo snap install code --classic' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Aha!', command: 'Web-based roadmapping platform' },
      { step: 'Install ProductBoard', command: 'Web-based product management platform' },
      { step: 'Install Amplitude', command: 'Web-based analytics platform' },
      { step: 'Install Tableau Desktop', command: 'brew install --cask tableau' },
      { step: 'Install Loom', command: 'brew install --cask loom' },
      { step: 'Install Calendly', command: 'Web-based scheduling platform' }
    ],
    windows: [
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' },
      { step: 'Install Microsoft Project', command: 'choco install microsoft-project' },
      { step: 'Install Visio', command: 'choco install visio' },
      { step: 'Install Azure Analytics', command: 'Web-based platform' },
      { step: 'Install Loom', command: 'choco install loom' },
      { step: 'Install OneNote', command: 'choco install onenote' }
    ],
    linux: [
      { step: 'Install draw.io desktop', command: 'sudo snap install drawio' },
      { step: 'Install Jupyter Notebook', command: 'pip3 install jupyter' },
      { step: 'Install Python analytics tools', command: 'pip3 install pandas numpy matplotlib seaborn' },
      { step: 'Install Docker', command: 'curl -fsSL https://get.docker.com -o get-docker.sh && sh get-docker.sh' },
      { step: 'Install Postman', command: 'sudo snap install postman' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Strategic Planning Suite', command: 'Configure enterprise planning tools' },
      { step: 'Install Advanced Analytics Tools', command: 'Set up business intelligence platforms' },
      { step: 'Install Executive Dashboard Tools', command: 'Configure executive reporting platforms' },
      { step: 'Install Innovation Management Tools', command: 'Set up innovation tracking platforms' }
    ],
    windows: [
      { step: 'Install Advanced Power Platform', command: 'Configure Power Platform Premium features' },
      { step: 'Install Dynamics 365', command: 'Configure Dynamics 365 for product insights' },
      { step: 'Install Azure DevOps Advanced', command: 'Set up enterprise Azure DevOps features' },
      { step: 'Install Microsoft Viva', command: 'Configure Viva suite for insights' }
    ],
    linux: [
      { step: 'Install Advanced Analytics Stack', command: 'pip3 install scikit-learn tensorflow plotly dash streamlit' },
      { step: 'Install Apache Superset', command: 'pip install apache-superset' },
      { step: 'Install Metabase', command: 'docker run -d -p 3000:3000 --name metabase metabase/metabase' },
      { step: 'Install Grafana', command: 'sudo apt-get install -y software-properties-common && sudo add-apt-repository "deb https://packages.grafana.com/oss/deb stable main" && sudo apt-get update && sudo apt-get install grafana' }
    ]
  }
};
